module.exports = __webpack_public_path__ + "img/P7-en.0f4a0647.png";